<template>
    <b-container flex>
        <b-row><span style="margin-left: 35px; color: darkgrey; font-family: Montserrat, sans-serif"><h3>CHECKLISTS</h3></span></b-row>
        <b-row v-for="winery in wineries" :key="winery.id">
            <b-col>
                <b-container style="margin-top: 20px;">
                    <span class="border-bottom border-dark">
                        <a href="#" @click="wineryClick(winery.surveyKey, winery.groupId,
                        winery.surveyResponseId, winery.entityType)">
                        {{ winery.name }}</a>
                    </span>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import '../compiled-icons'

export default {
  name: 'AdminSurveySelector',
  props: {
    value: Array,
    section: String,
    surveyKey: String
  },
  component: {},
  data() {
    return {
      listItems: this.value,
                sectionName: this.section,
                wineries: []
            }
        },
        mounted() {
            this.$http.get("survey/meta/new")
                .then(result => {
                    result.data.forEach(winery => {
                        this.wineries.push({
                          name: winery.winery,
                          surveyKey: winery.surveyId,
                          groupId: winery.groupId,
                          surveyResponseId: winery.surveyResponseId,
                          entityType: winery.entityType
                        })
                    });
                })
                .catch(error => {
                    console.log("The error: " + error.message);
                })
        },
        methods: {
          wineryClick(theKey, groupId, surveyResponseId, entityType) {
            console.log("Meta Info: " + theKey + " " + groupId + " " + surveyResponseId);
            // Here is where you add the if statement to got to the link based on the entity type.
            // console.log("Meta Info: " + theKey + " " + groupId + " " + surveyResponseId);
            localStorage.setItem('adminImpersonationGroupId', groupId);
            this.$store.commit('user/adminImpersonationGroupId', groupId);
            //let linkName = entityType.toLowerCase() === 'vineyard' ? 'Vineyard Page' : 'SurveyLink';
            let linkName = 'Vineyard Page';
            let actualParams = {surveyKey: theKey, groupId: groupId, mySurveyResponseId: surveyResponseId};
            this.$router.push({
              name: linkName,
              params: actualParams
            })
          }
        }
    }
</script>

<style>
    .vue-icon path[pid='0'] {
        fill: #42b983;
    }

    .vue-icon path[pid='1'] {
        fill: #35495e;
    }

    /* unvisited link */
    a:link {
        text-decoration: none;
    }

    /* visited link */
    a:visited {
        color: #808080;
    }

    /* mouse over link */
    a:hover {
        color: #333333;
    }

    /* selected link */
    a:active {
        color: #808080;
    }
</style>
